import { render, staticRenderFns } from "./ImportarPrecios.vue?vue&type=template&id=68b54f94&scoped=true&"
import script from "./ImportarPrecios.vue?vue&type=script&lang=js&"
export * from "./ImportarPrecios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../bym/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b54f94",
  null
  
)

export default component.exports